module.exports = __webpack_public_path__ + "img/vkus.09bdf22d.svg";